module.exports = __webpack_public_path__ + "img/modeltraining.c1baa3b0.png";